import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginConfigContainerModel} from '../../../../../models/aggregates/app-login';

@Injectable({providedIn: 'root'})
export class AppLoginConfigService extends BaseApiTemplateService<AppLoginConfigContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'app-login-configs';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'app-login-configs';
    this.httpClient = http;
  }

}
